export default {
      id: "article-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#article",
      toString: function () {
        return this.url;
      }
    }